// extracted by mini-css-extract-plugin
export default {"photo":"photoManagement_photo__zhdB8"};